define([
  'lib/underscore',
], function (_) {
  function from(arr) {
    var obj = _.first(arr);

    return _.keys(obj || {});
  }

  return { from: from };
});



// WEBPACK FOOTER //
// ./js/schema/properties.js